<template lang="pug">
div
  app-divider(label="Matrícula")
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/CNS")
        app-label(label="CNS:", :required="required")
        el-input.input(
          v-model="imovel.cnsMatricula",
          name='CNS',
          maxlength="50"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Número")
        app-label(label="Número:", :required="required")
        el-input.input(
          v-model="imovel.numeroMatricula",
          name='Número',
          maxlength="50",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Livro")
        app-label(label="Livro:", :required="required")
        el-input.input(
          v-model="imovel.livroMatricula",
          name='Livro',
          maxlength="50"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Nº da folha")
        app-label(label="Nº da folha:", :required="required")
        el-input.input(
          v-model="imovel.numeroFolhaMatricula",
          name='Número da folha',
          maxlength="50",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col(:span="6", v-if="inputsExtraCadastro.imovel.dataMatricula")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Nº da folha")
        app-label(label="Data da matrícula:", :required="required")
        el-date-picker.input.full-width(
          type="date",
          name='Data da matrícula'
          v-model="imovel.dataMatricula",
          placeholder="Selecione",
          format="dd/MM/yyyy",
          v-mask="'##/##/#####'",
          :picker-options="pickerOptions",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppLabel
  },
  data () {
    return {
      inputsExtraCadastro,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  props: {
    imovel: {
      required: true
    },
    // prop que define se os campos são obrigatorios
    required: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isRequired () {
      return this.required ? 'required' : ''
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}

.full-width {
  width: 100%;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/AppMatriculaImovel.vue